// extracted by mini-css-extract-plugin
export default {"halfWidth":"SubmissionDetails_halfWidth__UutlE","fullWidth":"SubmissionDetails_fullWidth__7dXtd"};